const css = `div.sri-manage {
  margin-top: 15px;
  margin-left: 50px;
  margin-right: 50px;
  font-family: Open Sans, sans-serif;
}

.sri-manage .school-status {
  color: #333333;
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 14px;
  line-height: 15px;
  font-family: Open Sans, sans-serif;
}
.sri-manage .school-status .sri-icon-inner {
  margin-right: 5px;
}

.sri-manage .breadcrumb {
  display: flex;
  flex-direction: row;
  margin-left: 20px;
}

.sri-manage .breadcrumb-base {
  display: flex;
}

.sri-manage .breadcrumb .sri-icon-inner {
  width: 12px;
  height: 12px;
  right: 0px;
  top: 3px;
  margin-left: 10px;
}

.sri-manage .breadcrumb .active-page-name {
  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
}

.sri-manage .goto-main {
  text-decoration-line: underline;
  cursor: pointer;
}

.sri-manage .page-title {
  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 27px;
  margin-top: 15px;
  margin-bottom: 15px;
  margin-left: 20px;
}

.sri-manage .page-content {
  margin-left: 20px;
}

.sri-manage .welcome-heading {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  margin-top: 20px;
}

.sri-manage .section-heading {
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  margin-top: 40px;
  margin-bottom: 10px;
}

.sri-manage .section-description {
  margin-bottom: 10px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
}

.sri-manage .activation-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  max-width: 730px;
  background-color: #f5f5f5;
  border-top: 1px solid #d6d6d6;
}

.sri-manage .activation-section .prod-description {
  font-weight: 600;
  font-size: 14px;
}

.sri-manage .activation-section button {
  font-family: inherit;
  background-color: #0075db;
  color: white;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  padding: 3px 40px;
  text-align: center;
  text-decoration: none;
  margin: 4px 2px;
  cursor: pointer;
  border-radius: 4px;
  border: 0px;
}
.sri-manage .activation-section button.button-active-completed {
  color: #3e8d21;
  background: white;
  border: 1px solid #3e8d21;
  cursor: default;
}

.sri-manage .hover-tooltip .sri-preview {
  width: 357px;
  height: 232px;
  margin-top: 10px;
}

.sri-manage .hover-tooltip .student-preview {
  width: 357px;
  height: 232px;
  margin-top: 10px;
}

.sri-manage .hover-tooltip {
  opacity: 1 !important;
}

.sri-manage .inline-notification {
  padding: 10px 20px;
  background-color: #def6f7;
  border-left: 3px solid #6bd7db;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  margin: 10px 0;
}

.sri-manage .edit-student-message .wysiwig-editor-container {
  max-width: 730px;
  margin-top: 10px;
}

.sri-manage .wysiwig-editor-container .wysiwig-info {
  display: flex;
  justify-content: space-between;
}

.sri-manage .wysiwig-editor-container .wysiwig-info .save-button {
  padding: 10px 20px;
  margin-top: 10px;
  border-radius: 4px;
}

.sri-manage .wysiwig-editor-container .wysiwig-info .save-button:disabled {
  opacity: 0.4;
  cursor: auto;
}

.sri-manage .inline-notification .suggested-action {
  font-weight: 400;
  padding-left: 20px;
}

.sri-manage .hover-tooltip-content {
  opacity: 1 !important;
  padding: 10px;
  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  width: 346px;
}

.sri-manage .notification-message-noimport {
  margin-left: 30px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
}

.sri-manage .inline-notification .close-notification {
  background-color: transparent;
  border: none;
  margin-left: 10px;
}

.sri-manage a.tooltip-trigger {
  border-bottom: 1px dashed #272728;
}

.activate-district-schools-drawer {
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  margin: 15px;
}

.activate-district-schools-subheading {
  padding-top: 25px;
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
}

.activate-district-schools-selection-count {
  margin-bottom: 10px;
  margin-top: 10px;
}

.activate-district-schools-drawer [role=table] .header-layout {
  display: flex;
  justify-content: space-between;
}

.activate-district-schools-drawer [role=table] .sort-arrow {
  margin-right: 10px;
}

.activate-district-schools-drawer [role=table] {
  width: 100%;
}

.activate-district-schools-drawer [role=table] .status-cell {
  display: flex;
  flex-direction: row;
  line-height: 21px;
}

.activate-district-schools-drawer [role=table] .status-cell .sri-icon-inner {
  margin-left: 5px;
  margin-right: 10px;
}

.activate-district-schools-drawer [role=table] input[type=checkbox] {
  margin-right: 10px;
}

.activate-district-schools-drawer [role=table] .header-dark-background {
  background-color: #d6d6d6 !important;
}

.activate-district-schools-drawer [role=columnheader] {
  background-color: #ebebeb;
}

.activate-district-schools-drawer .th,
.activate-district-schools-drawer .td {
  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 15px;
  cursor: pointer;
  height: 40px;
  text-align: left;
  padding-left: 10px;
}

.activate-district-schools-drawer .th:nth-child(2),
.activate-district-schools-drawer .td:nth-child(2) {
  width: 130px;
}

.sri-manage .activation-error {
  position: relative;
  margin: 10px 0;
  display: flex;
}
.sri-manage .activation-error .activation-error-inner {
  display: flex;
  align-items: center;
  padding: 16px 12px;
  background: #fdedef;
  border-left: 3px solid #da1e28;
}
.sri-manage .activation-error .activation-error-inner .activation-error-title {
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  color: #272728;
  margin-left: 10px;
  min-width: 110px;
}
.sri-manage .activation-error .activation-error-inner .activation-error-explanation {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #272728;
  margin-left: 10px;
}
.sri-manage .activation-error .activation-error-inner .activation-error-close-icon {
  margin-left: 15px;
}
.sri-manage .activation-error .activation-error-inner a.support-link {
  color: rgb(0, 0, 238);
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(359deg);
  }
}
.inprogress-spin-loader svg {
  animation: spin 1s linear infinite;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2FwcC9mcm9udGVuZC9zdGFmZi9jb250YWluZXJzL01hbmFnZVBhZ2UiLCJzb3VyY2VzIjpbIm1hbmFnZVBhZ2Uuc2NzcyIsIi4uLy4uL2RlZmluaXRpb25zLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUE7RUFDRTtFQUNBO0VBQ0E7RUFDQSxhQ1VpQjs7O0FEUG5CO0VBQ0UsT0NIaUI7RURJakI7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUNBO0VBQ0U7OztBQUlKO0VBQ0U7RUFDQTtFQUNBOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7OztBQU1GO0VBQ0UsYUM1QmlCO0VENkJqQjtFQUNBO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTs7O0FBR0Y7RUFDRSxhQ3hDaUI7RUR5Q2pCO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOzs7QUFNRjtFQUNFOzs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBLGtCQ25IYTtFRG9IYjtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUVBO0VBQ0UsT0NuSEk7RURvSEo7RUFDQTtFQUNBOzs7QUFJSjtFQUNFO0VBQ0E7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7OztBQUVGO0VBQ0U7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7RUFDQSxhQ2hMaUI7RURpTGpCO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTtFQUNBOzs7QUFHRjtFQUVFOzs7QUFFRjtFQUNFO0VBQ0E7RUFDQTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTs7O0FBR0Y7RUFDRTs7O0FBR0Y7RUFDRTs7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTs7O0FBR0Y7RUFDRTs7O0FBR0Y7RUFDRTs7O0FBR0Y7RUFDRTs7O0FBR0Y7QUFBQTtFQUVFLGFDbFFpQjtFRG1RakI7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7O0FBSUY7QUFBQTtFQUVFOzs7QUFHRjtFQUNFO0VBQ0E7RUFDQTs7QUFFQTtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFHRjtFQUNFOztBQUdGO0VBQ0U7OztBQUtOO0VBQ0U7SUFDRTs7RUFFRjtJQUNFOzs7QUFJSjtFQUNFIn0= */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
